import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Col, Row } from "reactstrap";
import SuburbService from "../../../services/SuburbServices/SuburbService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { Triangle } from "react-loader-spinner";
import DeleteModal from "../../../Components/Common/DeleteModal";
import SuburbForm from "../../Suburb/Component/SuburbForm";
import CountryForm from "../component/CountryForm";
import CountryService from "../../../services/CountryServices/CountryService";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";

const CountryPage = () => {
  const [countryData, setCountryData] = useState([]);
  console.log("🚀 ~ Suburb ~ countryData:", countryData);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: "Name",

      selector: (row) => (
        <Link to={`/country/detail/${row?.id}`}>{row?.name}</Link>
      ),
      sortable: true,
    },
    // {
    //   name: "Code",
    //   selector: (row) => row.code,
    //   sortable: true,
    // },
    // {
    //   name: "State",
    //   selector: (row) => row.states,
    //   sortable: true,
    // },
    // {
    //   name: "Zip Code",
    //   selector: (row) => row.states,
    //   sortable: true,
    // },
    {
      name: "Actions",
      cell: (row) => (
        <ButtonGroup className="gap-2">
          <Button
            color="warning"
            className="rounded-circle btn-sm"
            onClick={() => handleEdit(row)}
          >
            <i className="bx bx-edit"></i>
          </Button>
          <Button
            color="rounded-circle btn btn-danger"
            className="rounded-circle btn-sm gap-1"
            onClick={() => handleDeleteClick(row)}
          >
            <i className="bx bx-trash"></i>
          </Button>
        </ButtonGroup>
      ),
      center: true,
    },
  ];

  const [selectedSuburb, setSelectedSuburb] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleEdit = (item) => {
    setSelectedSuburb(item);
    setIsModalOpen(true);
  };

  const fetchCountries = async () => {
    try {
      const response = await CountryService.getList();
      console.log("🚀 ~ fetchCountries ~ response:", response);
      setCountryData(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchCountries();
  }, []);

  //==================== DELETE Functionality ===================================
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDeleteModal();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await CountryService.delete(selectedDeleteItem.id);
        setCountryData((prevList) =>
          prevList.filter((pkg) => pkg.id !== selectedDeleteItem.id)
        );
        toast.success("Selected country successfully deleted.");
      } catch (error) {
        toast.error("Failed to delete the country");
      } finally {
        toggleDeleteModal();
        setSelectedDeleteItem(null);
      }
    }
  };

  // ==================================================================================

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Country" pageTitle="Country List" />
      </div>
      <Row className="">
        <Col
          md={12}
          className="justify-content-end align-items-end alignn-content-end d-flex flex-column mb-2"
        >
          <Button
            className=""
            onClick={() => {
              setSelectedSuburb(null);
              setIsModalOpen(true);
            }}
          >
            + Add Country
          </Button>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            columns={columns}
            data={countryData || ""}
            customStyles={{
              headCells: {
                style: {
                  fontSize: "0.93rem",
                  fontWeight: 610,
                },
              },
              rows: {
                style: {
                  fontSize: "0.9rem",
                },
              },
            }}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
          />
        </Col>
      </Row>
      <CountryForm
        isOpen={isModalOpen}
        toggle={() => {
          setIsModalOpen(false);
          setSelectedSuburb(null);
        }}
        countryToEdit={selectedSuburb}
        setCountryData={setCountryData}
        countryData={countryData}
        fetchCountries={fetchCountries}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedDeleteItem} // Pass the selected item
      />
    </div>
  );
};

export default CountryPage;
